module.exports = __webpack_public_path__ + "static/about-content-image-6-2eb4224e7133c683c25adf8b3c0d5100.jpg";